import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AppBar, AppIcon, APP } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { appImages } from "../../assets/appicons";
import { EMP_BASE_PATH } from "../../config";

const MenuCard = ({ icon, label, onClick }) => (
  <Flex
    as="button"
    type="button"
    onClick={onClick}
    flex="1"
    direction="column"
    justify="space-between"
    h="96px"
    p="14px"
    borderRadius="12px"
    bg="#EEF5FF"
    border="1px solid"
    borderColor={APP.cardBorder}
    textAlign="left"
  >
    <AppIcon src={icon} size={28} color={APP.primary200} />
    <Text fontSize="14px" fontWeight={600} color={APP.textPrimary}>{label}</Text>
  </Flex>
);

const CollaboratorIndex = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const menuCards = (
    <>
        <Flex gap="12px">
          <MenuCard icon={appImages.icon_ctv} label="Cộng tác viên" onClick={() => navigate(`${EMP_BASE_PATH}/tai-chinh/cong-tac-vien/danh-sach`)} />
          <MenuCard icon={appImages.icon_phieu_dang_ky} label="Phiếu đăng ký CTV" onClick={() => navigate(`${EMP_BASE_PATH}/tai-chinh/cong-tac-vien/phieu`)} />
        </Flex>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title="Cộng tác viên" right={<DesktopBack onClick={() => navigate(EMP_BASE_PATH)} />}>
        <DesktopPanel>
          <Flex gap="16px" flexWrap="wrap" maxW="720px">
            {menuCards}
          </Flex>
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" bg="white" minH="100dvh">
      <AppBar title="Cộng tác viên" onBack={() => navigate(EMP_BASE_PATH)} />
      <Box px="16px" pt="12px">
        {menuCards}
      </Box>
    </Box>
  );
};

export default CollaboratorIndex;
